import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import ViewportContainer from '../ViewportContainer/ViewportContainer'
import GridContainer from '../GridContainer/GridContainer'
import { deviceMax, deviceMin } from '../../theme/breakpoints'

export const StyledHeroHeaderWrapper = styled.div`
    background-color: ${({ theme }) => theme.colors.unique.white};

    ${({ isFullMedia }) => (isFullMedia && `
        padding: ${pxToRem(24)};

        @media ${deviceMin.laptop} {
            padding: ${pxToRem(40)};
        }
    `
    )};
`

export const StyledViewportContainer = styled(ViewportContainer)`
    position: relative;

    ${({ isFullMedia }) => (isFullMedia && `
        min-height: ${pxToRem(475)};

        &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            display: block;
            width: 100%;
            height: 100%;    
            background: linear-gradient(
                190deg,
                rgba(0, 0, 0, 0) 25%, 
                rgba(0, 0, 0, 1) 100%
            );
        }

        @media ${deviceMax.laptop} {
            display: flex;
            flex-direction: column-reverse;
        }
    `
    )};
    
    @media ${deviceMin.laptop} {
        min-height: calc(${pxToRem(470)} - ${pxToRem(64)} * 2);
    }
`

export const StyledGridContainer = styled(GridContainer)`
    width: 100%;

    @media ${deviceMin.laptop} {
        min-height: inherit;
    }
`

export const StyledHeroBasicHeaderContent = styled.div`
    display: grid;
    gap: ${pxToRem(16)};
    text-align: center;
    z-index: 99;
    color: ${({ isFullMedia, theme }) => isFullMedia ? theme.colors.unique.white : theme.colors.unique.black};

    @media ${deviceMin.laptop} {
        text-align: inherit;
        align-content: center;
        justify-content: start;
    }
`

export const StyledHeroBasicHeaderVideo = styled.div`
    > video,
    > img { 
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        aspect-ratio: 1;
        object-fit: cover;
        max-width: ${({ $isFullMedia }) => (
        $isFullMedia ? `100%` : `calc(50% - ${pxToRem(125)} / 2)`
    )};
    }
`

export const StyledIFrame = styled.iframe`
  margin: auto;
  width: ${pxToRem(260)};
  height: ${pxToRem(125)};
  @media ${deviceMin.laptop} {
      position: absolute;
      right: 20px;
      z-index: 50;
  }
`